import type { Product } from "../../../mocks/products";

interface DeleteModalProps {
  product: Product;
  onConfirm: () => void;
  onClose: () => void;
}

export default function DeleteModal({ product, onConfirm, onClose }: DeleteModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl w-full max-w-sm p-7 shadow-2xl border border-gray-100">
        {/* Icon */}
        <div className="w-14 h-14 flex items-center justify-center bg-red-50 text-red-500 rounded-2xl mx-auto mb-5">
          <i className="ri-delete-bin-line text-3xl"></i>
        </div>
        <h3 className="text-gray-800 font-bold text-center text-lg mb-2">確認刪除</h3>
        <p className="text-gray-400 text-sm text-center leading-relaxed mb-6">
          確定要刪除<br />
          <strong className="text-gray-700">「{product.name}」</strong>？<br />
          此操作無法復原。
        </p>
        <div className="flex gap-3">
          <button onClick={onClose}
            className="flex-1 h-11 flex items-center justify-center border border-gray-200 text-gray-500 text-sm font-medium hover:bg-gray-50 transition-all duration-200 rounded-xl cursor-pointer whitespace-nowrap"
          >
            取消
          </button>
          <button onClick={onConfirm}
            className="flex-1 h-11 flex items-center justify-center bg-red-500 text-white text-sm font-semibold hover:bg-red-600 transition-colors duration-200 rounded-xl cursor-pointer whitespace-nowrap"
          >
            <i className="ri-delete-bin-line mr-1.5"></i>
            確認刪除
          </button>
        </div>
      </div>
    </div>
  );
}
